module.exports = __webpack_public_path__ + "static/media/choithramsHelpG.bf9c452b.png";